var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 512,
    height: 512,
    fill: "#d80027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M167.619,167.43l19.541,60.143H250.4l-51.161,37.171,19.542,60.143-51.161-37.17-51.162,37.17L136,264.744,84.837,227.573h63.239Z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M290.787,367.465,271.6,353.525l-19.184,13.939,7.327-22.553-19.185-13.94h23.716l7.326-22.553,7.331,22.553h23.713L283.459,344.91Z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M340.837,298.576H317.123l-7.329,22.554-7.327-22.553H278.751l19.187-13.94-7.329-22.552L309.8,276.021l19.185-13.938-7.329,22.553Z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M340.837,213.426l-19.185,13.94,7.328,22.551L309.8,235.981l-19.187,13.938,7.329-22.555-19.186-13.938h23.715L309.8,190.87l7.327,22.555Z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M290.787,144.536l-7.327,22.555,19.184,13.938H278.932l-7.33,22.556-7.328-22.557-23.714,0,19.185-13.941-7.329-22.555L271.6,158.476Z",
    fill: "#ffda44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZs);
export default __webpack_public_path__ + "static/media/zs.43c5a6abed939e404fd985f00bce74e4.svg";
export { ForwardRef as ReactComponent };